import '../styles/StepVisual.css';

/**
 * Square bordered image box used by each step. `src` is the path
 * under public/images/steps/ — see StepsSection.jsx for the mapping.
 */
export default function StepVisual({ src, alt = '' }) {
  return (
    <div className="step-visual">
      <img src={src} alt={alt} loading="lazy" />
    </div>
  );
}